export { default as WorkshopListAdmin } from './WorkshopListAdmin';
